import { Divider, Skeleton } from 'antd';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

export interface V2InfiniteScrollListProps {
  /**
   * @description 是否还有数据
   */
  hasMore?: boolean;
  /**
   * @description 数据长度
   */
  dataLength?: number;
  /**
   *@description 数据请求
   */
  loadData: () => void;
  /**
   *@description 没有更多数据时显示内容
   */
  endMessage?: React.ReactNode;
  /**
   *@description 加载中显示的内容
   */
  loader?: React.ReactNode;
  /**
   *@description 滚动区域对应的id
   */
  scrollableTargetId: any;
  children?: any;
}
/**
* @description 便捷文档地址
* @see https://reactpc.lanhanba.net/components/Data/v2infinite-scroll-list
*/
const V2InfiniteScrollList: React.FC<V2InfiniteScrollListProps> = ({
  hasMore = true,
  dataLength = 0,
  loadData,
  endMessage = <Divider plain>暂无更多</Divider>,
  loader = <Skeleton paragraph={{ rows: 1 }} active />,
  scrollableTargetId,
  children
}) => {
  return (
    <InfiniteScroll
      dataLength={dataLength}
      next={loadData}
      hasMore={hasMore}
      loader={loader}
      endMessage={endMessage}
      scrollableTarget={scrollableTargetId}
    >
      {children}
    </InfiniteScroll>
  );
};

export default V2InfiniteScrollList;
